import React from 'react';
import { PriceCta } from '../PriceCta';
export function IntroOffer() {
  return <section aria-labelledby="intro-offer" className="bg-white px-4 py-16 sm:py-20" data-id="element-226" data-mp="1bd6lznxgsx5e">
      <div className="mx-auto max-w-xl" data-id="element-227" data-mp="1gcjiz1i1vklp">
        <div className="overflow-hidden rounded-3xl bg-white shadow-[0_24px_60px_-20px_rgba(10,29,69,0.35)] ring-2 ring-cta" data-id="element-228" data-mp="1gdkvzbimmh62">
          <div className="bg-navy-900 px-5 py-6 text-center text-white sm:px-8" data-id="element-229" data-mp="1kdbrttn0fnhg">
            <p className="inline-flex items-center gap-2 rounded-full bg-alert px-3 py-1 text-xs font-extrabold uppercase tracking-wider" data-id="element-230" data-mp="np5fekjujqsm">
              <span className="h-2 w-2 animate-pulse-dot rounded-full bg-white" aria-hidden="true" data-id="element-231" data-mp="skkqj4qgz8lc" />
              The introductory offer
            </p>
            <h2 id="intro-offer" className="mt-4 font-display text-[1.75rem] font-black leading-tight sm:text-4xl [text-wrap:balance]" data-id="element-232" data-mp="11g280bdrw7zo">
              Get the complete ABG Clinical Roadmap™ for just $27 USD
            </h2>
            <p className="mt-3 text-white/75" data-id="element-233" data-mp="8x51lloof9z8">Six educational volumes. Five exclusive bonuses. One organized learning collection.</p>
          </div>
          <div className="px-5 py-7 sm:px-8" data-id="element-234" data-mp="3l90cgvohaxmx">
            <div className="mb-6 text-center" data-id="element-235" data-mp="3labqrpfjvnsa">
              <p className="text-base font-semibold text-ink/50" data-id="element-236" data-mp="3gia6phc54srp">
                Regular value <span className="line-through" data-id="element-237" data-mp="3bjqjzepq3cya">$237 USD</span>
              </p>
              <p className="font-display text-7xl font-black leading-none tracking-tight text-ink" data-id="element-238" data-mp="3bhmif3faqq16">
                $27<span className="ml-1 text-2xl font-extrabold text-ink/60" data-id="element-239" data-mp="36ijbfdfra9qk">USD</span>
              </p>
              <p className="mt-2 text-sm font-extrabold uppercase tracking-wider text-ok" data-id="element-240" data-mp="32lew3kg8qt9j">One-time payment</p>
            </div>
            <PriceCta label="Get the complete roadmap now" data-id="element-241" data-mp="2sl4kg49uttwh" />
          </div>
        </div>
      </div>
    </section>;
}